ixModuleRouting("impactx.supplierbaskettemplate", {
    "/supplierbaskettemplatelist": {
        template: "<ixa-supplier-basket-template-list></ixa-supplier-basket-template-list>",
        templateUrl:
            "modules/supplierbaskettemplate/templates/supplierbaskettemplatelist.html",
        controller: "SupplierBasketTemplateListCtrl",
        controllerAs: "supplierBasketTemplateListCtrl",
        process: "SupplierBasketTemplateList",
    },
});
